<template>
  <div class="member-recharge">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>充值管理</span>
          <el-button type="primary" @click="handleAdd">添加充值活动</el-button>
        </div>
      </template>
      
      <el-table :data="rechargeList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="amount" label="充值金额">
          <template #default="{ row }">
            ¥{{ row.amount }}
          </template>
        </el-table-column>
        <el-table-column prop="gift_amount" label="赠送金额">
          <template #default="{ row }">
            ¥{{ row.gift_amount }}
          </template>
        </el-table-column>
        <el-table-column prop="points" label="赠送积分" />
        <el-table-column prop="status" label="状态">
          <template #default="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="{ row }">
            <el-button type="primary" size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button type="danger" size="small" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    
    <!-- 编辑/添加对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="500px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="充值金额">
          <el-input-number v-model="form.amount" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="赠送金额">
          <el-input-number v-model="form.gift_amount" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="赠送积分">
          <el-input-number v-model="form.points" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch 
            v-model="form.status" 
            :active-value="1" 
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import request from '../../utils/request'

export default {
  name: 'MemberRecharge',
  setup() {
    const rechargeList = ref([])
    const dialogVisible = ref(false)
    const dialogTitle = ref('')
    const form = ref({})
    
    const fetchList = async () => {
      try {
        const res = await request.get('/api/admin/recharge-packages')
        rechargeList.value = res.data || []
      } catch (error) {
        // 后端尚未实现充值活动接口，显示空列表
        rechargeList.value = []
        console.warn('充值活动接口未实现')
      }
    }
    
    const handleAdd = () => {
      form.value = { status: 1, amount: 0, gift_amount: 0, points: 0 }
      dialogTitle.value = '添加充值活动'
      dialogVisible.value = true
    }
    
    const handleEdit = (row) => {
      form.value = { ...row }
      dialogTitle.value = '编辑充值活动'
      dialogVisible.value = true
    }
    
    const handleSave = async () => {
      try {
        if (form.value.id) {
          await request.put(`/api/admin/recharge-packages/${form.value.id}`, form.value)
        } else {
          await request.post('/api/admin/recharge-packages', form.value)
        }
        ElMessage.success('保存成功')
        dialogVisible.value = false
        fetchList()
      } catch (error) {
        ElMessage.error('保存失败，接口尚未实现')
      }
    }
    
    const handleDelete = async (row) => {
      try {
        await ElMessageBox.confirm('确认删除该活动？', '提示', { type: 'warning' })
        await request.delete(`/api/admin/recharge-packages/${row.id}`)
        ElMessage.success('删除成功')
        fetchList()
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除失败，接口尚未实现')
        }
      }
    }
    
    onMounted(() => {
      fetchList()
    })
    
    return {
      rechargeList,
      dialogVisible,
      dialogTitle,
      form,
      handleAdd,
      handleEdit,
      handleSave,
      handleDelete
    }
  }
}
</script>

<style scoped>
.member-recharge {
  padding: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.card-header span {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}
</style>
